'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /**
                    * Created by Administrator on 2016/9/26.
                    */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PersonalCenterBecomePartner = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(PersonalCenterBecomePartner, _Component);

  function PersonalCenterBecomePartner() {
    (0, _classCallCheck3.default)(this, PersonalCenterBecomePartner);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(PersonalCenterBecomePartner).apply(this, arguments));
  }

  (0, _createClass3.default)(PersonalCenterBecomePartner, [{
    key: 'render',
    value: function render() {
      var styles = require('./PersonalCenterBecomePartner.scss');
      return _react2.default.createElement(
        'div',
        { className: styles.component },
        _react2.default.createElement(
          'div',
          { className: styles.img },
          _react2.default.createElement('img', {
            src: 'http://tupian.goeasy.cn:9999/yipinwang/qrcode_for_gh_25e78b6d8f17_430.jpg' })
        ),
        _react2.default.createElement(
          'div',
          { className: styles.txt },
          '请使用微信扫一扫关注公众号'
        )
      );
    }
  }]);
  return PersonalCenterBecomePartner;
}(_react.Component), _class.propTypes = {}, _temp);
exports.default = PersonalCenterBecomePartner;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/PersonalCenterBecomePartner/PersonalCenterBecomePartner.js
 ** module id = 1518
 ** module chunks = 0
 **/